import PropTypes from 'prop-types';

import IconLoading from '../../LEGACY/javascripts/ui/icon/icon-loading';

const BookNowSpinner = ({ showSpinner = false }) => {
  const className = `booknow--spinner-loader ${
    showSpinner ? 'booknow--spinner-loader__visible' : ''
  }`;

  return (
    <div className={className}>
      <IconLoading />
    </div>
  );
};

BookNowSpinner.propTypes = {
  showSpinner: PropTypes.bool
};

export default BookNowSpinner;
